import { Component, OnInit, Input, DoCheck } from '@angular/core';

import { FormaControleService } from "../../../bens/formas-controle/shared/forma-controle.service";

@Component({
    selector: 'app-odometro-horimetro-label-component',
    template: require('./odometro-horimetro-label.component.html'),
    styles: [require('./odometro-horimetro-label.component.css')]
})
export class OdometroHorimetroLabelComponent implements OnInit, DoCheck {
    @Input() labelOdometro: string = '';
    @Input() labelHorimetro: string = '';
    @Input() bemObject: any = {};
    @Input() odometroHorimetroObject: any = {};

    private odometro: number;
    private horimetro: number;
    private showOdometro: boolean = false;

    constructor(
        private _formaControleService: FormaControleService
    ){}

    ngOnInit() {
        this.horimetro = this._formaControleService.getFormaControleHorimetro();
        this.odometro = this._formaControleService.getFormaControleOdometro();
    }

    ngDoCheck() {
       if (this.bemObject) {
           if (this.bemObject.formaControleId === this.odometro) {
               this.showOdometro = true;
           } else {
               this.showOdometro = false;
           }
       }
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/odometros-horimetros/odometro-horimetro-label/odometro-horimetro-label.component.ts
 **/